import type { RumEvent } from '@datadog/browser-rum'

// Slack sends the browser back with a one-time completion token in
// `?slack_state=`. It stays in the URL until the connect completes, so RUM
// would record it on the views started in the meantime.
const SLACK_STATE_PARAM = 'slack_state'

const withoutSlackState = (url: string): string => {
    let parsed: URL
    try {
        parsed = new URL(url)
    } catch {
        return url
    }
    if (!parsed.searchParams.has(SLACK_STATE_PARAM)) {
        return url
    }
    parsed.searchParams.delete(SLACK_STATE_PARAM)
    return parsed.toString()
}

export function scrubSlackState(event: RumEvent): void {
    event.view.url = withoutSlackState(event.view.url)
    if (event.view.referrer) {
        event.view.referrer = withoutSlackState(event.view.referrer)
    }
}
